<template>
  <div class="empty-box">
    <div class="empty-img"><img src="https://st.moneydata.hk/res/uploadcdn-static/hkwallet/general/20231018143947/empty.png" /></div>
    <div class="empty-message">{{ message }}</div>
  </div>
</template>

<script>
import { defineComponent, computed } from '@vue/composition-api';
import { i18n } from '../../i18n';
import { useRecordList, ListKind } from '../../store/record-list';
import { storeToRefs } from 'pinia';

export default defineComponent({
  setup() {
    const { kind } = storeToRefs(useRecordList());
    const message = computed(() => (kind.value === ListKind.Store ? i18n('您本月未獲得過印花') : i18n('您本月未換領過獎賞')));

    return {
      message,
    };
  },
});
</script>

<style scoped lang="less">
@rem: 200rem;

.empty-box {
  flex: 1;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.empty-img img {
  width: 140/@rem;
  height: 150/@rem;
}
.empty-message {
  font-size: 28/@rem;
  line-height: 40/@rem;
  color: rgba(136, 136, 136, 1);
  text-align: center;
}
</style>
